module.exports = __webpack_public_path__ + "img/close-text-upload.9d4cfbc4.png";